<template>
    <Loading v-bind:show="showLoadingValorBruto" v-if="$featureToggle && $featureToggle.INTEGRA_MENSALIDADES_VALORBRUTO">
        <PageTitle title="Mensalidades - Valor Bruto" />
        <Grid v-if="dadosAba"
              v-bind:Data="dadosAba.valorBruto"
              v-bind:Header="headerValorBruto"
              Name="ValorBruto"
              OrderBy="ano"
              v-bind:HeaderDetalhes="null"
              v-bind:DetalhesCombo1="dadosAba.competencia"
              v-bind:DetalhesCombo2="null"
              v-bind:DetalhesCombo3="null" />
    </Loading>
</template>
<script>
    import Grid from '@/components/Grid';
    import Loading from '@/components/Loading';
    import PageTitle from '@/components/PageTitle';
    import Mensalidades from '@/services/MensalidadesService.js';
    export default {
        components: {
            Grid,
            Loading,
            PageTitle
        },
        created() {
            this.mensalidadesService = new Mensalidades(this);

            //Verifica se tem aluno selecionado
            if (!sessionStorage.Aluno) {
                this.$router.push('home');
            }
            else {
                let a = JSON.parse(sessionStorage.Aluno);
                //Coloca o perfil de aluno disponível na variável aluno
                if (a.PerfilAluno) {
                    this.aluno = a.PerfilAluno;
                    //Verifica se os dados da Aba ja esta carregado
                    if (a.MensalidadesValorBruto) {
                        this.dadosAba = a.MensalidadesValorBruto;
                    }
                    else {
                        this.dadosAba = this.valorBruto();
                    }
                }
                else
                    this.$router.push('home');
            }
        },
        beforeDestroy() {
            let aluno = JSON.parse(sessionStorage.Aluno);

            //Armazena os dados da aba pra nao precisar carregar novamente
            aluno.MensalidadesValorBruto = this.dadosAba;
            sessionStorage.setItem("Aluno", JSON.stringify(aluno));
        },
        data() {
            return {
                aluno: null,
                headerValorBruto: [
                    {
                        Titulo: "Competência",
                        Field: "anoMes",
                        Width: "80px",
                        Tipo: "texto"
                    },
                    {
                        Titulo: "Ano",
                        Field: "ano",
                        Width: "80px",
                        Tipo: "numero"
                    },
                    {
                        Titulo: "Mes",
                        Field: "mes",
                        Width: "80px",
                        Tipo: "numero"
                    },
                    {
                        Titulo: "Valor Bruto",
                        Field: "valor_titulo",
                        Width: "80px",
                        Tipo: "moeda"
                    },
                    {
                        Titulo: "Desconto",
                        Field: "valorDesconto",
                        Width: "80px",
                        Tipo: "texto"
                    }
                ],
                dadosAba: null,
                showLoadingValorBruto: false,
                retornoValorBruto: null
            }
        },
        methods: {
            valorBruto() {
                if (this.$featureToggle.INTEGRA_MENSALIDADES_VALORBRUTO) {
                    this.showLoadingValorBruto = true;
                    this.mensalidadesService.ListarValorBruto({
                        CodigoAluno: this.aluno.codigoAluno,
                        CodigoEspecialidade: this.aluno.codigoEspecialidade,
                        Mes: null,
                        Ano: null
                    }).then(
                        data => {
                            if (data.ok) {
                                this.dadosAba = data.dados;
                            }
                            else {
                                this.$modal.alert(data.mensagem);
                            }
                        },
                        error => {
                            this.$modal.error((error.body?.Mensagem || 'Ocorreu um erro ao tentar buscar os dados.'), (error.body?.Detalhe || error?.response?.statusText || error.message));
                        }).finally(() => {
                            this.showLoadingValorBruto = false;
                        });
                }
                else {
                    this.$modal.alert(this.$msgFeatureToggle);
                }
            }
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .md-field {
        max-width: 100%;
        font-weight: bold;
    }

    .md-tab {
        padding: 0;
        margin: 0 !important;
    }
</style>
